import { render, staticRenderFns } from "./ItemDataEbay.vue?vue&type=template&id=096046b9&scoped=true&"
import script from "./ItemDataEbay.vue?vue&type=script&lang=js&"
export * from "./ItemDataEbay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096046b9",
  null
  
)

export default component.exports